import { Close } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const EXCLUDE_LABEL = [
  {
    id: 1,
    label: "Slab",
    value: "slab",
  },
  {
    id: 2,
    label: "Value",
    value: "value1",
  },
  {
    id: 3,
    label: "Value",
    value: "value2",
  },
  {
    id: 4,
    label: "",
    value: "",
  },
];
const ITEM_LABEL = [
  {
    id: 1,
    label: "Item",
    value: "item",
  },
  {
    id: 2,
    label: "Sharing",
    value: "sharing",
  },
  {
    id: 3,
    label: "",
    value: "",
  },
];

const MasterSharingCriteriaTab = ({ template = {}, onChange = () => {}, readOnly = false }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [checkboxStates, setCheckboxStates] = useState({
    excludeCriteria: template?.excludeCriteria || false,
    visitDoctor: template?.visitDoctor || false,
    provider: template?.provider || false,
    referredDoctor: template?.referredDoctor || false,
    anesthesia: template?.anesthesia || false,
    surgery: template?.surgery || false,
    surgeryBill: template?.surgeryBill || false,
    procedure: template?.procedure || false,
    systemUser: template?.systemUser || false,
    investigation: template?.investigation || false
  });

  const [excludedDepartments, setExcludedDepartments] = useState([
    {
      slab: "Greater Than",
      value1: "0",
      value2: "",
    },
  ]);

  const [item, setItem] = useState([]); // Initialize as empty array

  const [formData, setFormData] = useState(template || {});

  // Update local state when template prop changes
  useEffect(() => {
    if (template) {
      setFormData(template);
      setCheckboxStates({
        excludeCriteria: template?.excludeCriteria || false,
        visitDoctor: template?.visitDoctor || false,
        provider: template?.provider || false,
        referredDoctor: template?.referredDoctor || false,
        anesthesia: template?.anesthesia || false,
        surgery: template?.surgery || false,
        surgeryBill: template?.surgeryBill || false,
        procedure: template?.procedure || false,
        systemUser: template?.systemUser || false,
        investigation: template?.investigation || false
      });
    }
  }, [template]);

  // Initialize item state with template data if available
  useEffect(() => {
    if (template?.item) {
      setItem(template.item);
    }
  }, [template]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxStates(prev => ({
      ...prev,
      [name]: checked
    }));
    onChange({ ...checkboxStates, [name]: checked });
  };

  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  // handle add item
  const handleAddTableRow = (currentElement, currentState, newRowData) => {
    currentState([...currentElement, newRowData]);
  };

  // handle remove item
  const handleRemoveTableRow = (rowIndex, currentElement, currentState) => {
    currentState(currentElement?.filter((_, index) => index !== rowIndex));
  };

  // Function to update input values in the state
  const handleInputChange = (event, rowIndex, currentState) => {
    const { value, name } = event.target;

    // Update state without modifying the original array
    currentState((prevState) =>
      prevState.map((row, i) =>
        i === rowIndex ? { ...row, [name]: value } : row
      )
    );
  };

  return (
    <Box>
      {/* first box */}
      <Box
        sx={{
          backgroundColor: "rgba(240, 247, 252, 1)",
          borderRadius: "12px",
          mb: "30px",
          p: "20px",
        }}
      >
        <Typography sx={{ mb: "20px", color: "rgba(93, 106, 130, 1)" }}>
          Sharing Criteria
        </Typography>

        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="excludeCriteria" 
                  checked={checkboxStates.excludeCriteria}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Exclude Criteria"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="visitDoctor" 
                  checked={checkboxStates.visitDoctor}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Visit Doctor"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="provider" 
                  checked={checkboxStates.provider}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Provider"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="referredDoctor" 
                  checked={checkboxStates.referredDoctor}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Referred Doctor"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="anesthesia" 
                  checked={checkboxStates.anesthesia}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Anesthesia"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="surgery" 
                  checked={checkboxStates.surgery}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Surgery"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="surgeryBill" 
                  checked={checkboxStates.surgeryBill}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Surgery Bill"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="procedure" 
                  checked={checkboxStates.procedure}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Procedure"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="systemUser" 
                  checked={checkboxStates.systemUser}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="System User"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <FormControlLabel
              control={
                <Checkbox 
                  name="investigation" 
                  checked={checkboxStates.investigation}
                  onChange={handleCheckboxChange}
                  disabled={readOnly}
                />
              }
              label="Investigation"
            />
          </Grid>
        </Grid>
      </Box>

      {/* second box */}
      <Box
        sx={{
          border: `1px solid #CCD4DA`,
          borderRadius: "12px",
          mb: "30px",
          p: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "20px",
          }}
        >
          <Typography>Sharing Detail</Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                bgcolor: "#EAEAEA",
              }}
            >
              <TableRow>
                {EXCLUDE_LABEL?.map((option) => (
                  <TableCell
                    key={option?.id}
                    sx={{
                      textAlign: option?.align || "left",
                      color: "#5D6A82",
                    }}
                  >
                    {option?.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {excludedDepartments?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {EXCLUDE_LABEL?.map((column, columnIndex) => (
                    <TableCell
                      key={`${rowIndex}${columnIndex}`}
                      sx={{ color: "#5D6A82" }}
                    >
                      {columnIndex === EXCLUDE_LABEL?.length - 1 ? (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Close
                            sx={{ cursor: "pointer", fontSize: "18px" }}
                            onClick={() =>
                              handleRemoveTableRow(
                                rowIndex,
                                excludedDepartments,
                                setExcludedDepartments
                              )
                            }
                          />
                        </Box>
                      ) : (
                        <TextField
                          label={column?.label}
                          required
                          fullWidth
                          name={column?.value}
                          value={row[column?.value] || ""}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              rowIndex,
                              setExcludedDepartments
                            )
                          }
                        />
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                <TableCell
                  colSpan={EXCLUDE_LABEL?.length}
                  sx={{ color: "#92A6CC", cursor: "pointer" }}
                  onClick={() =>
                    handleAddTableRow(
                      excludedDepartments,
                      setExcludedDepartments,
                      {}
                    )
                  }
                >
                  + Add item
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* third box */}
      <Box
        sx={{
          border: `1px solid #CCD4DA`,
          borderRadius: "12px",
          mb: "30px",
          p: "20px",
        }}
      >
        {/* tabs */}
        <Box
          sx={{
            border: "1px solid grey",
            borderRadius: "5px",
            px: 2,
            py: 0.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 3,
            width: "500px",
            cursor: "pointer",
            mb: "20px",
          }}
        >
          <Typography
            onClick={() => handleTabClick(0)}
            sx={{
              color: "grey",
              textDecoration: "none",
              ...(activeTab === 0 && {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }),
            }}
          >
            Item
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography
            onClick={() => handleTabClick(1)}
            sx={{
              color: "grey",
              textDecoration: "none",
              ...(activeTab === 1 && {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }),
            }}
          >
            Sub Category
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography
            onClick={() => handleTabClick(2)}
            sx={{
              color: "grey",
              textDecoration: "none",
              ...(activeTab === 2 && {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }),
            }}
          >
            Category
          </Typography>
          <Divider flexItem orientation="vertical" />
          <Typography
            onClick={() => handleTabClick(3)}
            sx={{
              color: "grey",
              textDecoration: "none",
              ...(activeTab === 3 && {
                color: "primary.main",
                fontWeight: 600,
                textDecoration: "underline",
                textUnderlineOffset: "4px",
              }),
            }}
          >
            Package Items
          </Typography>
        </Box>

        {/* tab values */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 4, mb: "20px" }}>
          <FormControlLabel
            control={<Checkbox name="giveSharingBedCategoryWise" />}
            label="Give Sharing Bed Category Wise"
            sx={{ color: "#5D6A82" }}
          />

          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography sx={{ color: "#5D6A82" }}>Sharing:</Typography>
            <Autocomplete
              options={[]}
              renderInput={(params) => <TextField {...params} label="Amount" />}
              sx={{ minWidth: "150px" }}
            />
            <TextField />
          </Box>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead
              sx={{
                bgcolor: "#EAEAEA",
              }}
            >
              <TableRow>
                {ITEM_LABEL?.map((option) => (
                  <TableCell
                    key={option?.id}
                    sx={{
                      textAlign: option?.align || "left",
                      color: "#5D6A82",
                    }}
                  >
                    {option?.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {item?.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {ITEM_LABEL?.map((column, columnIndex) => (
                    <TableCell
                      key={`${rowIndex}${columnIndex}`}
                      sx={{ color: "#5D6A82" }}
                    >
                      {columnIndex === ITEM_LABEL?.length - 1 ? (
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 1 }}
                        >
                          <Close
                            sx={{ cursor: "pointer", fontSize: "18px" }}
                            onClick={() =>
                              handleRemoveTableRow(rowIndex, item, setItem)
                            }
                          />
                        </Box>
                      ) : (
                        <>
                          <TextField
                            label={column?.label}
                            required
                            fullWidth
                            name={column?.value}
                            value={row[column?.value] || ""}
                            onChange={(e) =>
                              handleInputChange(e, rowIndex, setItem)
                            }
                          />
                        </>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                <TableCell
                  colSpan={ITEM_LABEL?.length}
                  sx={{ color: "#92A6CC", cursor: "pointer" }}
                  onClick={() =>
                    handleAddTableRow(excludedDepartments, setItem, {})
                  }
                >
                  + Add item
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default MasterSharingCriteriaTab;
